import { CashReconciliationComponent } from './pages/cash-reconciliation/cash-reconciliation.component';
import { SquareReconciliationComponent } from './pages/square-reconciliation/square-reconciliation.component';
import { WorkloadForecastTestsComponent } from './tests/workload-forecast-tests/workload-forecast-tests.component';
import { NgModule, isDevMode } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { NgxMasonryModule } from 'ngx-masonry';
import { QRCodeModule } from 'angularx-qrcode';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MaterialModule } from './material-module';
import { HttpClientModule } from '@angular/common/http';
import { SideNavigationComponent } from './components/side-navigation/side-navigation.component';
import { StatusComponent } from './components/status/status.component';
import { StatusDirective } from './directives/status.directive';
import { DashboardComponent } from './pages/dashboard/dashboard.component';
import { humanPipe } from './pipes/human-currency';
import { HumanDirective } from './directives/human.directive';
import { accountPipe } from './pipes/account-pipe';
import { isMobilePipe, isPhonePipe, phonePipe } from './pipes/phone-pipe';
import { TasksComponent } from './pages/tasks/tasks.component';
import { TimeagoModule } from 'ngx-timeago';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TaskCreateComponent } from './pages/task-create/task-create.component';
import { MoneyInputComponent } from './components/money-input/money-input.component';
import { CustomerDialogComponent } from './dialogs/customer/customer.dialog';
import { PickCustomerComponent } from './components/pick-customer/pick-customer.component';
import { RequestReviewDialog } from './dialogs/request-review/request-review.dialog';
import { PendingRevenueComponent } from './pages/pending-revenue/pending-revenue.component';
import { TransactionDialogComponent } from './dialogs/transaction-dialog/transaction.dialog';
import { NgxDropzoneModule } from 'ngx-dropzone';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { AutomationComponent } from './pages/automation/automation.component';
import { InventoryListComponent } from './pages/inventory-list/inventory-list.component';
import { InventoryCreateComponent } from './pages/inventory-create/inventory-create.component';
import { InvoicesComponent } from './pages/invoices/invoices.component';
import { CustomersComponent } from './pages/customers/customers.component';
import { TransactionsComponent } from './pages/transactions/transactions.component';
import { InvoicesCreateComponent } from './pages/invoices-create/invoices-create.component';
import { ItemSearchDialogComponent } from './dialogs/item-search/item-search.dialog';
import { DateFilterDialogComponent } from './dialogs/date-filter/date-filter.dialog';
import { ProductsComponent } from './pages/products/products.component';
import { InvoiceDeleteDialogComponent } from './dialogs/invoice-delete/invoice-delete.dialog';
import { PendingEvidenceViewerDialogComponent } from './dialogs/pending-evidence-viewer/pending-evidence-viewer.dialog';
import { ByPassSecurityPipe } from './pipes/bypass-security';
import { AccountingComponent } from './pages/books/books.component';
import { AtoQuaterComponent } from './reports/ato-quater/ato-quater.component';
import { WageSustainabilityComponent } from './reports/wage-sustainability/wage-sustainability.component';
import { AveragePerformanceComponent } from './reports/average-performance/average-performance.component';
import { BankAccountSettingsComponent } from './pages/settings/bank-account-settings/bank-account-settings.component';
import { TestsComponent } from './pages/tests/tests.component';
import { PDFTestsComponent } from './tests/pdf-tests/pdf-tests.component';
import { EmailTestsComponent } from './tests/email-tests/email-tests.component';
import { SMSTestsComponent } from './tests/sms-tests/sms-tests.component';
import { LoginComponent } from './pages/login/login.component';
import { CustomerImportDialogComponent } from './dialogs/customer-import/customer-import.dialog';
import { JobTestsComponent } from './tests/job-tests/job-tests.component';
import { JsonViewerDialogComponent } from './dialogs/json-viewer/json-viewer.dialog';
import { RecordPaymentDialogComponent } from './dialogs/record-payment/record-payment.dialog';
import { EmailInvoiceDialogComponent } from './dialogs/email-invoice/email-invoice.dialog';
import { BankTransferTestsComponent } from './tests/bank-transfer-tests/bank-transfer-tests.component';
import { EmailReceiptDialogComponent } from './dialogs/email-receipt/email-receipt.dialog';
import { TemplateTestsComponent } from './tests/template-tests/template-tests.component';
import { DialogLabComponent } from './tests/dialog-lab/dialog-lab.component';
import { QRGeneratorTestsComponent } from './tests/qr-generator-tests/qr-generator-tests.component';
import { MpdTestsComponent } from './tests/mpd-tests/mpd-tests.component';
import { SquareTestsComponent } from './tests/square-tests/square-tests.component';
import { InvoiceStandardComponent } from './invoice-components/invoice-standard/invoice-standard.component';
import { InvoiceMSPComponent } from './invoice-components/invoice-msp/invoice-msp.component';
import { InvoiceEwasteComponent } from './invoice-components/invoice-ewaste/invoice-ewaste.component';
import { SendSMSDialog } from './dialogs/send-sms/send-sms.dialog';
import { SendSMSResultDialog } from './dialogs/send-sms/send-sms-result.dialog';
import { InvoicePromptDialogComponent } from './dialogs/invoice-prompt/invoice-prompt.dialog';
import { CommonModule } from '@angular/common';
import { ItemSidebarComponent } from './inventory-item-components/item-sidebar/item-sidebar.component';
import { InventoryItemFeaturesComponent } from './inventory-item-components/item-features/item-features.component';
import { ImageDialogComponent } from './dialogs/image-dialog/image.dialog';
import { ItemNeedsImprovementComponent } from './inventory-item-components/item-needs-improvement/item-needs-improvement.component';
import { ItemTitleComponent } from './inventory-item-components/item-title/item-title.component';
import { InventoryWebsiteDialogComponent } from './dialogs/inventory-website/inventory-website.dialog';
import { PdfGenerateComponent } from './dialogs/pdf-generate/pdf-generate.component';
import { AngularPinturaModule } from '@pqina/angular-pintura';
import { ImageDownloadDialogComponent } from './dialogs/image-download-dialog/image-download-dialog.component';
import { ItemEbayComponent } from './inventory-item-components/item-ebay/item-ebay.component';
import { ItemFacebookComponent } from './inventory-item-components/item-facebook/item-facebook.component';
import { ItemSellComponent } from './inventory-item-components/item-sell/item-sell.component';
import { ItemMediaComponent } from './inventory-item-components/item-media/item-media.component';
import { SalesChannelDialog } from './dialogs/sales-channel-dialog/sales-channel.dialog';
import { EbayTestsComponent } from './tests/ebay-tests/ebay-tests.component';
import { PdfViewerComponent } from './components/pdf-viewer/pdf-viewer.component';
import { InventoryManagerComponent } from './pages/inventory-manager/inventory-manager.component';
import { InventoryNeedsImprovementsComponent } from './pages/inventory-needs-improvements/inventory-needs-improvements.component';
import { InventoryRepairQueueComponent } from './pages/inventory-repair-queue/inventory-repair-queue.component';
import { InvoiceTaskComponent } from './invoice-components/invoice-task/invoice-task.component';
import { DynamicDirective } from './directives/dynamic.directive';
import { NewItemTemplateComponent } from './pages/new-item-template/new-item-template.component';
import { SettingsComponent } from './pages/settings/settings.component';
import { CKEditorModule } from '@ckeditor/ckeditor5-angular';
import { InvoiceEbayComponent } from './invoice-components/invoice-ebay/invoice-ebay.component';
import { InvoiceEbayNewDesignComponent } from './invoice-components/invoice-ebay-new-design/invoice-ebay-new-design.component';
import { EbayRevenueDialogComponent } from './dialogs/ebay-revenue-dialog/ebay-revenue.dialog';
import { SquareRevenueDialogComponent } from './dialogs/square-revenue-dialog/square-revenue.dialog';
import { InventoryItemDialogComponent } from './dialogs/inventory-item-dialog/inventory-item.dialog'
import { TaskDialogComponent } from './dialogs/task-dialog/task.dialog';
import { ItemWebflowComponent } from './inventory-item-components/item-webflow/item-webflow.component';
import { MobileHeaderComponent } from './components/mobile-header/mobile-header.component';
import { InventoryItemFeatureDialogComponent } from './dialogs/inventory-item-feature/inventory-item-feature.dialog';
import { InventoryComponent } from './pages/inventory/inventory.component';
import { ForumIndexComponent } from './forum-components/forum-index/forum-index.component';
import { PostViewComponent } from './forum-components/post-view/post-view.component';
import { AccountsComponent } from './pages/accounts/accounts.component';
import { InvoiceRepairComponent } from './invoice-components/invoice-repair/invoice-repair.component';
import { JobProgressDialogComponent } from './dialogs/job-progress/job-progress.component';
import { ServiceWorkerModule } from '@angular/service-worker';
import { SelectOptionDialog } from './dialogs/select-option-dialog/select-option.dialog';
import { SnoozeDialogComponent } from './dialogs/snooze-dialog/snooze.dialog';
import { SearchComponent } from './components/search/search.component';
import { InvoiceHisenseComponent } from './invoice-components/invoice-hisense/invoice-hisense.component';
import { InvoiceLineItemFindDialogComponent } from './dialogs/invoice-line-item-find/invoice-line-item-find.dialog';
import { InvoiceDialogComponent } from './dialogs/invoice-dialog/invoice.dialog';
import { InventoryItemNoteComponent } from './inventory-item-components/inventory-item-note/inventory-item-note.component';
import { InventoryCatRenameDialogComponent } from './dialogs/inventory-cat-rename-dialog/inventory-cat-rename.dialog';
import { NoSpaceDirective } from './directives/mat-select-no-space.directive';
import { RevenueComponent } from './pages/revenue/revenue.component';
import { InputTextComponent } from './components/input-text/input-text.component';
import { InputNoteComponent } from './components/input-note/input-note.component';
import { InputSelectComponent } from './components/input-select/input-select.component';
import { NgApexchartsModule } from 'ng-apexcharts';
import { InputMoneyComponent } from './components/input-money/input-money.component';
import { InputRadioComponent } from './components/input-radio/input-radio.component';
import { ExpensesTaxFiguresDialogComponent } from './dialogs/expenses-tax-figures/expenses-tax-figures.dialog';
import { SocialsComponent } from './pages/socials/socials.component';
import { InventoryItemTemplateDialogComponent } from './dialogs/inventory-item-template-dialog/inventory-item-template.dialog';
import { NgVar } from './directives/var.directive';
import { InventoryCategoryNewDialogComponent } from './dialogs/inventory-category-new-dialog/inventory-category-new.dialog';
import { InvoiceSolvupComponent } from './invoice-components/invoice-solvup/invoice-solvup.component';
import { RCTIEwasteComponent } from './invoice-components/rcti-ewaste/rcti-standard.component';
import { RunSheetDialogComponent } from './dialogs/run-sheet-dialog/run-sheet.dialog';
import { PDFDialogComponent } from './dialogs/pdf-dialog/pdf.dialog';
import { inventoryCategoriesDialogComponent } from './dialogs/inventory-categories-dialog/inventory-categories.dialog';
import { InventoryCategoriesComponent } from './components/inventory-categories/inventory-categories.component';
import { CashDialogComponent } from './dialogs/cash-dialog/cash.dialog';
import { KiosModeDialog } from './dialogs/kios-mode/kios-mode.dialog'
import { KioskComponent } from './pages/kiosk/kiosk.component';
import { ReceiptsComponent } from './pages/receipts/receipts.component';
import { PartsOrderedComponent } from './pages/parts-ordered/parts-ordered.component';
import { PayPayrollDialogComponent } from './dialogs/payroll-pay/payroll-pay.dialog';
import { DateInputComponent } from './components/date-input/date-input.component';
import { RemoteComponent } from './pages/remote/remote.component';
import { RemoteClientDialogComponent } from './dialogs/remote-client-dialog/remote-client-dialog.component';
import { TransactionRangeDialogComponent } from './dialogs/transaction-range/transaction-range.dialog';
import { PartsOrderDialog } from './dialogs/parts-order-dialog/parts-order.dialog';
import { CalendarComponent } from './pages/calendar/calendar.component';
import { CalendarEntryDialogComponent } from './dialogs/calendar-entry-dialog/calendar-entry-dialog.component';
import { CalendarPickerDialogComponent } from './dialogs/calendar-picker-dialog/calendar-picker-dialog.component';
import { TransactionPresetDialogComponent } from './dialogs/transaction-preset-dialog/transaction-preset.dialog';
import { PaymentDetailDialogComponent } from './dialogs/payment-detail/payment-detail.dialog';
import { SearchPageComponent } from './pages/search/search.component';
import { ReceiptUploadDialogComponent } from './dialogs/receipt-upload-dialog/receipt-upload.dialog';
import { RCTIRepairLabComponent } from './invoice-components/rcti-repairlab/rcti-repairlab.component';
import { WeeklyReportComponent } from './reports/weekly-report/weekly-report.component';
import { TaskCompleteConfirmDialog } from './dialogs/task-complete-confirm/task-complete-confirm.dialog';
import { WebsiteEnquiriesComponent } from './pages/website-enquiries/website-enquiries.component';
import { ApiDocsDialogComponent } from './dialogs/api-docs/api-docs.dialog';
import { InvoiceMemoryImportComponent } from './pages/invoice-memory-import/invoice-memory-import.component';
import { PaymentLinkerOnceComponent } from './pages/payment-linker-once/payment-linker-once.component';
import { WebsiteEnquiryDetailDialogComponent } from './dialogs/website-enquiry-detail/website-enquiry-detail.dialog';
import { TaskCreateDialog } from './dialogs/task-create/task-create.dialog';
import { CustomerSearchDialogComponent } from './dialogs/customer-search/customer-search.dialog';
import { MusicComponent } from './pages/music/music.component';

import { PhoneDirective } from './directives/phone.directive';
import { PhoneDialogComponent } from './dialogs/phone/phone.dialog';

@NgModule({
  declarations: [
    CashReconciliationComponent,
    SquareReconciliationComponent,
    WorkloadForecastTestsComponent,
    PhoneDirective,
    PhoneDialogComponent,
    AppComponent,
    SideNavigationComponent,
    DashboardComponent,
    TasksComponent,
    TaskCreateComponent,
    StatusComponent,
    StatusDirective,
    DynamicDirective,
    NoSpaceDirective,
    NgVar,
    HumanDirective,
    humanPipe,
    accountPipe,
    isPhonePipe,
    phonePipe,
    isMobilePipe,
    MoneyInputComponent,
    DateInputComponent,
    CustomerDialogComponent,
    PickCustomerComponent,
    RequestReviewDialog,
    PendingRevenueComponent,
    TransactionDialogComponent,
    AutomationComponent,
    InventoryListComponent,
    InventoryCreateComponent,
    SideNavigationComponent,
    InvoicesComponent,
    CustomersComponent,
    TransactionsComponent,
    InvoicesCreateComponent,
    StatusDirective,
    ItemSearchDialogComponent,
    DateFilterDialogComponent,
    ProductsComponent,
    PendingEvidenceViewerDialogComponent,
    InvoiceDeleteDialogComponent,
    EbayRevenueDialogComponent,
    MoneyInputComponent,
    PickCustomerComponent,
    humanPipe,
    accountPipe,
    isPhonePipe,
    phonePipe,
    isMobilePipe,
    ByPassSecurityPipe,
    AccountingComponent,
    AtoQuaterComponent,
    AutomationComponent,
    WageSustainabilityComponent,
    AveragePerformanceComponent,
    BankAccountSettingsComponent,
    TestsComponent,
    PendingRevenueComponent,
    PDFTestsComponent,
    EmailTestsComponent,
    SMSTestsComponent,
    LoginComponent,
    CustomerImportDialogComponent,
    JobTestsComponent,
    JsonViewerDialogComponent,
    RecordPaymentDialogComponent,
    EmailInvoiceDialogComponent,
    BankTransferTestsComponent,
    EmailReceiptDialogComponent,
    TemplateTestsComponent,
    DialogLabComponent,
    QRGeneratorTestsComponent,
    MpdTestsComponent,
    SquareTestsComponent,
    InvoiceStandardComponent,
    InvoiceMSPComponent,
    InvoiceEwasteComponent,
    InvoiceEbayComponent,
    InvoiceEbayNewDesignComponent,
    InvoiceSolvupComponent,
    InvoiceTaskComponent,
    SendSMSDialog,
    SendSMSResultDialog,
    ItemSidebarComponent,
    InventoryItemFeaturesComponent,
    ImageDialogComponent,
    ItemNeedsImprovementComponent,
    ItemTitleComponent,
    InventoryWebsiteDialogComponent,
    PdfGenerateComponent,
    ImageDownloadDialogComponent,
    ItemEbayComponent,
    ItemFacebookComponent,
    ItemSellComponent,
    ItemWebflowComponent,
    ItemMediaComponent,
    SalesChannelDialog,
    EbayTestsComponent,
    PdfViewerComponent,
    InventoryManagerComponent,
    InventoryNeedsImprovementsComponent,
    InventoryRepairQueueComponent,
    NewItemTemplateComponent,
    SettingsComponent,
    SquareRevenueDialogComponent,
    InventoryItemDialogComponent,
    TaskDialogComponent,
    MobileHeaderComponent,
    InventoryItemFeatureDialogComponent,
    InventoryComponent,
    ForumIndexComponent,
    PostViewComponent,
    AccountsComponent,
    InvoiceRepairComponent,
    JobProgressDialogComponent,
    SelectOptionDialog,
    SnoozeDialogComponent,
    SearchComponent,
    InvoiceHisenseComponent,
    InvoiceLineItemFindDialogComponent,
    InvoiceDialogComponent,
    InventoryItemNoteComponent,
    InventoryCatRenameDialogComponent,
    RevenueComponent,
    InputTextComponent,
    InputNoteComponent,
    InputSelectComponent,
    InputMoneyComponent,
    InputRadioComponent,
    ExpensesTaxFiguresDialogComponent,
    SocialsComponent,
    InventoryItemTemplateDialogComponent,
    InventoryCategoryNewDialogComponent,
    RCTIEwasteComponent,
    RCTIRepairLabComponent,
    RunSheetDialogComponent,
    PDFDialogComponent,
    inventoryCategoriesDialogComponent,
    InventoryCategoriesComponent,
    CashDialogComponent,
    KiosModeDialog,
    KioskComponent,
    ReceiptsComponent,
    PartsOrderedComponent,
    PayPayrollDialogComponent,
    RemoteComponent,
    RemoteClientDialogComponent,
    TransactionRangeDialogComponent,
    TransactionPresetDialogComponent,
    PartsOrderDialog,
    PaymentDetailDialogComponent,
    SearchPageComponent,
    InvoicePromptDialogComponent,
    CalendarComponent,
    CalendarEntryDialogComponent,
    CalendarPickerDialogComponent,
    ReceiptUploadDialogComponent,
    WeeklyReportComponent,
    TaskCompleteConfirmDialog,
    WebsiteEnquiriesComponent,
    ApiDocsDialogComponent,
    PaymentLinkerOnceComponent,
    InvoiceMemoryImportComponent,
    WebsiteEnquiryDetailDialogComponent,
    TaskCreateDialog,
    CustomerSearchDialogComponent,
    MusicComponent
  ],
  imports: [
    BrowserModule,
    CommonModule,
    TimeagoModule.forRoot(),
    FormsModule,
    ReactiveFormsModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    MaterialModule,
    HttpClientModule,
    NgApexchartsModule,
    NgxDropzoneModule,
    PdfViewerModule,
    AngularPinturaModule,
    CKEditorModule,
    NgxMasonryModule,
    QRCodeModule,
    ServiceWorkerModule.register('ngsw-worker.js', {
      enabled: !isDevMode(),
      // Register the ServiceWorker as soon as the application is stable
      // or after 30 seconds (whichever comes first).
      registrationStrategy: 'registerWhenStable:30000'
    })
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
